module.exports = __webpack_public_path__ + "static/media/2_16.cfe2e16e.png";